import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const Banner_URL = `${API_URL}/banner`;

const listBanner = () => {
  return axios.get(`${Banner_URL}/list`).then((response) => {
    return response;
  });
};

const createBanner = (formData: FormData) => {
  return axios.post(`${Banner_URL}/add`,  formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Set Content-Type header to multipart/form-data
    }}).then((response) => {
    return response;
  });
};

const updateBanner = (formData: FormData, id: any) => {
  return axios.put(`${Banner_URL}/edit/${id}`,  formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Set Content-Type header to multipart/form-data
    }}).then((response) => {
    return response;
  });
};

const viewBanner = (id: any) => {
  return axios.get(`${Banner_URL}/view/${id}`).then((response) => {
    return response;
  });
};

const deleteBanner = (id: any , userId : number ) => {
  return axios.put(`${Banner_URL}/delete/${id}` ,{userId}).then((response) => {
    return response;
  });
};

const checkDuplicate = (name: any) => {
  return axios.post(`${Banner_URL}/duplicate`, { name }).then((response) => {
    return response;
  });
};

export {
  listBanner,
  createBanner,
  updateBanner,
  viewBanner,
  deleteBanner,
  checkDuplicate,
};
